var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { formHelperTextClasses } from '@mui/material/FormHelperText';
export var createMuiFormHelperTextOverrides = function (_a) {
    var _b;
    var spacing = _a.spacing, typography = _a.typography, tokens = _a.tokens;
    return {
        defaultProps: {
            variant: 'outlined',
        },
        styleOverrides: {
            root: __assign(__assign({ marginTop: spacing(1) }, typography.body2), (_b = { '&:empty': {
                        marginTop: 0,
                    } }, _b["&.".concat(formHelperTextClasses.error)] = {
                color: tokens.color_fg_state_danger,
            }, _b)),
            contained: {
                marginLeft: 0,
                marginRight: 0,
            },
            sizeSmall: {
                marginTop: spacing(1),
            },
        },
    };
};
